var _title, _desc, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgElectricityBuy = function SvgElectricityBuy(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "3E742B77-4752-423B-A669-FBBF189CAFC4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ele-buy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ele-buy",
    transform: "translate(-51.000000, -87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico/bolt/red",
    transform: "translate(51.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20284023,1.50065765 C9.06674607,1.49207239 8.93748029,1.56806002 8.86651556,1.69836283 L3.61095692,8.45079238 C3.54123689,8.54010769 3.50193914,8.65412803 3.5,8.77272796 C3.5,9.10723159 3.8212138,9.37889495 4.21798193,9.37889495 L7.80702809,9.37889495 L6.77085453,14.5298642 C6.77085453,14.697116 6.93146144,14.8329477 7.12962963,14.8329477 C7.25352221,14.8388051 7.37238387,14.7776599 7.44911648,14.6685962 L12.7353286,7.86492764 L12.7353286,7.86492764 C12.797081,7.77884394 12.8315531,7.67223764 12.8333333,7.56184414 C12.8333333,7.22734051 12.5121195,6.95567715 12.1153514,6.95567715 L8.52501002,6.95567715 L9.56118358,1.80470792 C9.56204706,1.63648933 9.40100842,1.50065765 9.20284023,1.50065765 Z",
    fill: "#B00020",
    fillRule: "nonzero"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElectricityBuy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/electricity-buy.d4d8a429.svg";
export { ForwardRef as ReactComponent };